/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{transformPropOrder as t}from"./transform.js";const e={x:"translateX",y:"translateY",z:"translateZ",transformPerspective:"perspective"},r=t.length;function n(n,{enableHardwareAcceleration:a=!0,allowTransformNone:o=!0},s,l){let i="";for(let a=0;a<r;a++){const r=t[a];if(void 0!==n[r]){i+=`${e[r]||r}(${n[r]}) `}}return a&&!n.z&&(i+="translateZ(0)"),i=i.trim(),l?i=l(n,s?"":i):o&&s&&(i="none"),i}export{n as buildTransform};
//# sourceMappingURL=build-transform.js.map
